import React from 'react';
import { MilestoneStatus } from './MilestoneStatusBadge';

interface MilestoneMetadataProps {
  status: MilestoneStatus;
  delayReason?: string;
  earlyCompletion?: boolean;
  earlyCompletionReason?: string;
  className?: string;
}

const MilestoneMetadata: React.FC<MilestoneMetadataProps> = ({
  status,
  delayReason,
  earlyCompletion,
  earlyCompletionReason,
  className = '',
}) => {
  const hasMetadata = (status === 'delayed' && delayReason) || (earlyCompletion && earlyCompletionReason);

  if (!hasMetadata) return null;

  return (
    <div className={`space-y-2 ${className}`}>
      {status === 'delayed' && delayReason && (
        <div className="flex items-start gap-2 text-red-600 bg-red-50 p-2 rounded">
          <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <strong>Delay Reason:</strong> {delayReason}
          </div>
        </div>
      )}
      {earlyCompletion && earlyCompletionReason && (
        <div className="flex items-start gap-2 text-green-600 bg-green-50 p-2 rounded">
          <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <div>
            <strong>Early Completion:</strong> {earlyCompletionReason}
          </div>
        </div>
      )}
    </div>
  );
};

export default MilestoneMetadata;

